export default __webpack_public_path__ + "static/small-business-economy-accomplishment-3d-719ac0666591145ebd06650b334c3290.webp";